import {
  Scoreboard,
  ScoreboardParticipant,
  ScoreboardParticipants,
  ScoreboardScore,
  ScoreboardScores
} from '@ps/isp-web-component-library';
import type { EnrichedParticipants, EventId } from '@ps/isp-web-services-types';
import React from 'react';

import type { TennisMatch } from '@swf/generated/graphql/scoreboards/schemas';
import { EventTypeId } from '@swf/sports/types/eventType';

import ScoreboardWrapper from '../ScoreboardWrapper/ScoreboardWrapper';

interface Props {
  enrichedParticipants?: EnrichedParticipants;
  eventId: EventId;
  eventTime: string;
  tennisMatch?: TennisMatch;
}

const Tennis: React.FC<Props> = ({ enrichedParticipants, tennisMatch, eventId, eventTime }) => {
  const [participantA, participantB] = enrichedParticipants ?? [];
  const currentSet = tennisMatch?.currentSet;
  const currentGame = currentSet?.currentGame;
  const currentServingParticipant = currentGame?.teamServing;

  return (
    <ScoreboardWrapper eventId={eventId} eventTime={eventTime} eventTypeId={EventTypeId.TENNIS}>
      <Scoreboard>
        <ScoreboardParticipants>
          <ScoreboardParticipant
            name={participantA.participant}
            isVisibleMarker={currentServingParticipant === participantA.type}
          />
          <ScoreboardParticipant
            name={participantB.participant}
            isVisibleMarker={currentServingParticipant === participantB.type}
          />
        </ScoreboardParticipants>
        <ScoreboardScores>
          <ScoreboardScore
            score={[tennisMatch?.teamAScore ?? null, tennisMatch?.teamBScore ?? null]}
          />
          <ScoreboardScore
            score={[currentSet?.teamAScore ?? null, currentSet?.teamBScore ?? null]}
          />
          <ScoreboardScore
            score={[currentGame?.teamAScore ?? null, currentGame?.teamBScore ?? null]}
            isDoubleDigit
          />
        </ScoreboardScores>
      </Scoreboard>
    </ScoreboardWrapper>
  );
};

export default Tennis;
